import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

const DISMISS_KEY = "cloudivo_install_prompt_dismissed_at";
const DISMISS_COOLDOWN_DAYS = 14;

export function InstallPrompt() {
  const [deferredEvent, setDeferredEvent] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      const dismissedAt = localStorage.getItem(DISMISS_KEY);
      if (dismissedAt) {
        const daysSince = (Date.now() - Number(dismissedAt)) / (1000 * 60 * 60 * 24);
        if (daysSince < DISMISS_COOLDOWN_DAYS) return;
      }
      setDeferredEvent(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setVisible(false);
  };

  const install = async () => {
    if (!deferredEvent) return;
    deferredEvent.prompt();
    await deferredEvent.userChoice;
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 glass-panel rounded-2xl px-5 py-4 flex items-center gap-4 shadow-2xl border border-amber-400/20 max-w-sm w-[calc(100%-2rem)]"
      data-testid="install-prompt-banner"
    >
      <img src="/icons/cloudivo-mark.png" alt="Cloudivo" className="w-9 h-9 object-contain shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-white">Install Cloudivo</p>
        <p className="text-xs text-slate-400">Add the app to your home screen for quick, full-screen access.</p>
      </div>
      <button onClick={install} data-testid="install-prompt-install-btn" className="bg-amber-400 hover:bg-amber-300 text-background font-semibold text-xs px-3.5 py-2 rounded-lg shrink-0">
        <Download className="w-3.5 h-3.5 inline mr-1" /> Install
      </button>
      <button onClick={dismiss} data-testid="install-prompt-dismiss-btn" className="text-slate-400 hover:text-white shrink-0">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
